import React, { useState, useRef, useEffect, useContext } from 'react'

import AppContext from '../../contexts/AppContext'
import Breadcrumbs from '../Breadcrumbs'
import Header from '../Header'
import Footer from '../Footer'
import { breadcrumbsBy } from '../../services/locations'
import { avatarFrom } from '../../services/users'

import useToastContext from "../../hooks/useToastContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faUpload, faTimes } from '@fortawesome/free-solid-svg-icons'
import { Helmet } from "react-helmet-async";

const BusinessProfileLogo = ({ user, company, onChange }) => {

    const [ loading, setLoading ] = useState(false)
    const [ deleting, setDeleting ] = useState(false)

    const { imageServices } = useContext(AppContext)

    const addToast = useToastContext()

    const onImagesSelected = e => {
        const file = e.target.files && e.target.files[0]
        if(file){
            setLoading(true)
            return imageServices.upload(file, company.id, 'App\\Company', {
                replace: true,
                width: 500,
                height: 500,
                fit: 'yes'
            }).then(res => {
                if(typeof onChange == 'function') onChange(res)
                setLoading(false)
            }).catch(res => {
                if(res && res.data && res.data.message) addToast({title: 'Error', message: res.data.message, type: 'danger'})
                setLoading(false)
            })
        }
    }

    const deleteLogo = id => {
        setDeleting(true)
        return imageServices.delete(id).then(res => {
            if(typeof onChange == 'function') onChange(res)
            setDeleting(false)
        }).catch(res => {
            if(res && res.data && res.data.message) addToast({title: 'Error', message: res.data.message, type: 'danger'})
            setDeleting(false)
        })
    }

    const logoSrc = avatarFrom(user, '200_200_crop')

    return (
        <>
            <div className="card mb-3">
                <div className="card-body">
                    <div className="d-flex">
                        <div className="text-center me-3">
                            <img
                                src={logoSrc}
                                className="avatar-img"
                                style={{
                                    width: '100px',
                                    height: '100px',
                                    borderRadius: '100px'
                                }}
                            />
                        </div>
                        <div className="">
                            <h4 className="card-title">Business Logo</h4>
                            <div className="mb-1">
                                {loading &&
                                    <button className="btn btn-primary me-2" disabled={true}>
                                        <FontAwesomeIcon icon={faSpinner} spin />
                                        <span className="ms-2">Upload/Update Logo</span>
                                    </button>
                                }
                                {!loading &&
                                    <label className="btn btn-primary mb-0 me-2">
                                        <FontAwesomeIcon icon={faUpload} />
                                        <span className="ms-2">Upload/Update Logo</span>
                                        <input
                                            type="file"
                                            onChange={onImagesSelected}
                                            accept="image/png, image/jpeg"
                                            multiple
                                            hidden
                                            required
                                        />
                                    </label>
                                }
                                {company?.image &&
                                    <button
                                        onClick={e => {
                                            e.preventDefault()
                                            deleteLogo(company.image.id)
                                        }}
                                        disabled={deleting}
                                        className="btn btn-outline-danger"
                                    >
                                        {deleting ? (
                                            <FontAwesomeIcon icon={faSpinner} className="me-2" spin />
                                        ) : (
                                            <FontAwesomeIcon icon={faTimes} className="me-2" />
                                        )}
                                        <span>Remove Logo</span>
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const BusinessProfile = ({ match, history }) => {

    const { data, location } = useContext(AppContext)
    const { app } = data
    const { user } = app

    if(!user) return null

    const title = "Business Profile"
    const isBusinessProfile = user.profile_type == 1

    const { companyServices, setAppState } = useContext(AppContext)
    const addToast = useToastContext()

    const [ company, setCompany ] = useState()
    const [ loading, setLoading ] = useState(false)
    const [ submitting, setSubmitting ] = useState(false)

    const [ timestamp, setTimestamp ] = useState(new Date().getTime())

    const canSubmitCompany = company && company.name && company.phone && company.description ? true : false

    const loadData = () => {
        setLoading(true)
        companyServices.byUser().then(res => {
            if(res.company) setCompany(res.company)
            if(res.user) setAppState('app.user', res.user)
            setLoading(false)
        }).catch(err => {
            addToast({title: 'Error', message: err?.data?.message ? err.data.message : 'Something went wrong', type: 'danger'})
        })
    }

    const onSubmit = data => {
        return new Promise((resolve, reject) => {
            setSubmitting(true)
            return companyServices.update(company.id, data).then(res => {
                if(res.company) setCompany(res.company)
                setSubmitting(false)
                addToast({title: 'Success', message: 'Save/Update success', type: 'success'})
                resolve(res.company)
            }).catch(err => {
                setSubmitting(false)
                addToast({title: 'Error', message: err?.data?.message ? err.data.message : 'Something went wrong', type: 'danger'})
                reject(err?.data)
            })
        })
    }

    useEffect(() => {
        loadData()
    }, [ timestamp ])

    return (
        <>
            <div>
                <Header history={history} />
                <main className="py-4">
                    <div className="container">

                        <Breadcrumbs list={breadcrumbsBy(location, [{url: '/account', title: 'Dashboard'}, {title}])} />

                        <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>

                        <h1>{title}</h1>

                        {loading &&
                            <div className="text-center my-5"><FontAwesomeIcon icon={faSpinner} spin /></div>
                        }

                        {(!loading && company && isBusinessProfile) &&
                            <div>

                                <BusinessProfileLogo
                                    user={user}
                                    company={company}
                                    onChange={() => setTimestamp(new Date().getTime())}
                                />

                            </div>
                        }
                    </div>
                </main>
            </div>
            <Footer />
        </>
    )
}

export default BusinessProfile
